import './service.css';

import ServiceCard from 'components/service_card';
import { domain, main_domain, ogImage } from 'config';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Content from '../../components/card';

import { getService, getServiceIdle } from 'store/ducks/service/actions';
import { selectorCards } from 'store/ducks/service/selector';
import Card from 'components/card/card';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

type Props = {};

const Service = (props: Props) => {
    // console.log(props);

    const { slug }: any = useParams();

    const dispatch = useDispatch();

    const { status, data }: any = useSelector(
        (state: { service: any }) => state.service
    );

    const cards = useSelector(selectorCards);

    useEffect(() => {
        if (status == 'SUCCESS') {
            console.log(cards);
            dispatch(getServiceIdle());
        }
    }, [status]);

    useEffect(() => {
        if (status == 'IDLE') {
            dispatch(
                getService({
                    slug: slug,
                })
            );
        }
    }, []);

    return (
        <>
            <Helmet>
                <meta
                    property="og:url"
                    content={main_domain + '/services/' + slug}
                />
                <meta property="og:site_name" content="Нормальный Дубай" />
                <title>
                    {(data &&
                        data.attributes &&
                        ((data.attributes.OG_Title &&
                            data.attributes.OG_Title) ||
                            data.attributes.Title)) ||
                        ''}
                </title>
                <meta
                    name="description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                ></meta>
                <meta property="og:type" content="page" />
                <meta
                    property="og:title"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Title &&
                                data.attributes.OG_Title) ||
                                data.attributes.Title)) ||
                        ''
                    }
                />
                <meta
                    property="og:description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                />
                <meta
                    property="og:image"
                    content={
                        (data && data.ogurl) ||
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta
                    property="vk:image"
                    content={
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="vk:image:width" content="537" />
                <meta property="vk:image:height" content="240" />
                <meta
                    property="twitter:image"
                    content={
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="twitter:image:width" content="1024" />
                <meta property="twitter:image:height" content="512" />
                <meta
                    name="twitter:title"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Title &&
                                data.attributes.OG_Title) ||
                                data.attributes.Title)) ||
                        ''
                    }
                />
                <meta
                    name="twitter:description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                />
                <meta name="twitter:card" content="summary_large_image" />
                <link
                    rel="canonical"
                    href={main_domain + '/services/' + slug}
                />
            </Helmet>
            <div className="page _service">
                <div className="container">
                    <div className="page__entry">
                        <div className="card">
                            <div className="page__preview">
                                {data &&
                                    data.attributes &&
                                    data.attributes.Preview && (
                                        <>
                                            <img
                                                src={
                                                    domain +
                                                    data.attributes.Preview.data
                                                        .attributes.url
                                                }
                                            />
                                        </>
                                    )}
                            </div>
                            {data && data.attributes && data.attributes.Title && (
                                <>
                                    <h1
                                        className="_h2"
                                        dangerouslySetInnerHTML={{
                                            __html: data.attributes.Title,
                                        }}
                                    ></h1>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="page__content">
                        {cards.map((components: any, index: any) => {
                            return <Card key={index} components={components} />;
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Service;
